import { Component, AfterViewInit, Input, ViewChild, Renderer2,ElementRef } from "@angular/core";

@Component({
  selector: 'expandable',
  templateUrl: 'expandable.html'
})
export class ExpandableComponent  implements AfterViewInit {

  text: string;
  @ViewChild("expandWrapper", { read: ElementRef, static: false}) expandWrapper: ElementRef;
  @Input("expanded") expanded: boolean = false;
  @Input("expandHeight") expandHeight: string = "150px";

  constructor(public renderer: Renderer2) {}

  ngAfterViewInit() {
    this.renderer.setStyle(this.expandWrapper.nativeElement, "max-height", this.expandHeight);
  }
}



// WEBPACK FOOTER //
// ./src/components/expandable/expandable.ts